import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getownerhorsekindStats = createSlice({
    name: 'ownerhorsekindstats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchownerhorsekindStats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchownerhorsekindStats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchownerhorsekindStats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setTrainer, setStatus } = getownerhorsekindStats.actions;
export default getownerhorsekindStats.reducer;

export const fetchownerhorsekindStats = createAsyncThunk('/ownerhorsekindstats/fetch', async ({ id }) => {
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const res = await axios.get(`${baseUrl}/OwnerHorseByKind/${id}`);
    const trainerstatsData = res.data;
    return trainerstatsData;
})